import { Launch } from '@mui/icons-material';
import { Link, Stack } from '@mui/material';
import { useLaunchFeatureFlags } from '../../../../services/featureFlags/hooks/useLaunchFeatureFlags';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

export const FeatureFlagsLauncher = () => {
  const { t } = useTranslation();

  const handleClick = useLaunchFeatureFlags();

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{ alignItems: 'center', padding: 2 }}
      color='text.secondary'
    >
      <Launch fontSize='small' />
      <Link
        variant='subtitle1'
        onClick={handleClick}
        underline='hover'
        color='inherit'
      >
        {t('Go to LaunchDarkly')}
      </Link>
    </Stack>
  );
};
